import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = ({ disableTarget }) => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order_limit.limit_type.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order_limit.limit_amount.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order_limit.limit_count.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order_limit.period.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order_limit.payment_type.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('priority.label', { count: 1 })} />
  </TableCell>
  {!disableTarget && <TableCell align='center'>
    <TextHeader label={I18n.t('target')} />
  </TableCell>}
  {!disableTarget && <TableCell align='center'>
    <TextHeader label={I18n.t('name.label', { count: 1 })} />
  </TableCell>}
</>

export default React.memo(Header)
